// @ts-nocheck
(function () {
  let MOBILE_MQ = '(max-width: 749.9px)';
  let AUTO_HOVER_MS = 4000;

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function getSlideVideo(slide) {
    return slide ? slide.querySelector('.see-it-in-motion__video') : null;
  }

  function getSlideViewAll(slide) {
    return slide ? slide.querySelector('.see-it-in-motion__view-all--slide') : null;
  }

  function syncMobileViewAll(sectionEl, slide) {
    let mobileLink = sectionEl.querySelector('[data-see-it-in-motion-view-all-mobile]');
    if (!mobileLink || !slide) return;
    let url = slide.getAttribute('data-view-all-url');
    if (url) {
      mobileLink.setAttribute('href', url);
    }
  }

  function showPoster(slide) {
    if (!slide) return;
    slide.querySelector('.see-it-in-motion__video-wrap')?.classList.remove('is-playing');
    let video = getSlideVideo(slide);
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {}
  }

  function playSlideVideo(slide) {
    if (!slide) return;
    let video = getSlideVideo(slide);
    if (!video) return;

    if (video.readyState === 0) {
      video.load();
    }

    slide.querySelector('.see-it-in-motion__video-wrap')?.classList.add('is-playing');
    video.play().catch(function () {});
  }

  function pauseAllSlides(swiperEl) {
    swiperEl.querySelectorAll('[data-see-it-in-motion-slide]').forEach(showPoster);
  }

  function getRealSlides(swiperEl) {
    return Array.prototype.slice.call(
      swiperEl.querySelectorAll('.swiper-slide[data-see-it-in-motion-slide]:not(.swiper-slide-duplicate)')
    );
  }

  function getActiveSlide(swiper, swiperEl) {
    if (swiper && swiper.slides && typeof swiper.activeIndex === 'number') {
      return swiper.slides[swiper.activeIndex] || null;
    }
    return swiperEl.querySelector('.swiper-slide-active[data-see-it-in-motion-slide]');
  }

  function syncViewAllA11y(slides, activeIndex) {
    slides.forEach(function (slide, index) {
      let link = getSlideViewAll(slide);
      if (!link) return;
      let isActive = index === activeIndex;
      link.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      link.setAttribute('tabindex', isActive ? '0' : '-1');
    });
  }

  function initSeeItInMotionSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.seeItInMotionInit === 'true') return;
    if (typeof Swiper === 'undefined') {
      window.setTimeout(function () {
        initSeeItInMotionSection(sectionEl);
      }, 50);
      return;
    }

    sectionEl.dataset.seeItInMotionInit = 'true';

    let swiperEl = sectionEl.querySelector('.see-it-in-motion__swiper');
    if (!swiperEl) return;

    let slideCount = sectionEl.querySelectorAll(
      '.swiper-slide[data-see-it-in-motion-slide]:not(.swiper-slide-duplicate)'
    ).length;
    if (slideCount === 0) return;

    let inViewport = false;
    let swiper = null;
    let observer = null;
    let mediaQuery = window.matchMedia(MOBILE_MQ);
    let activeHoverIndex = Math.floor((slideCount - 1) / 2);
    let isUserHovering = false;
    let autoHoverTimer = null;
    let hoverBound = false;

    function getSlides() {
      return getRealSlides(swiperEl);
    }

    /**
     * Before Swiper init CSS centers the row; after init Swiper left-aligns.
     * Re-center whenever slides still fit the container.
     */
    function syncDesktopCentering() {
      if (!swiper || !swiper.wrapperEl) return;

      if (isMobile()) {
        swiperEl.classList.remove('is-sim-centered');
        swiper.wrapperEl.style.width = '';
        swiper.wrapperEl.style.marginLeft = '';
        swiper.wrapperEl.style.marginRight = '';
        return;
      }

      let slides = getSlides();
      if (!slides.length) return;

      let spaceBetween = (swiper.params && swiper.params.spaceBetween) || 32;
      let totalWidth = 0;
      slides.forEach(function (slide, index) {
        totalWidth += slide.offsetWidth || 0;
        if (index < slides.length - 1) totalWidth += spaceBetween;
      });

      let containerWidth = swiper.width || swiperEl.clientWidth || 0;
      let fits = containerWidth > 0 && totalWidth <= containerWidth + 1;

      if (fits) {
        swiperEl.classList.add('is-sim-centered');
        swiper.wrapperEl.style.width = totalWidth + 'px';
        swiper.wrapperEl.style.marginLeft = 'auto';
        swiper.wrapperEl.style.marginRight = 'auto';
        if (typeof swiper.setTranslate === 'function') {
          swiper.setTranslate(0);
        } else {
          swiper.wrapperEl.style.transform = 'translate3d(0px, 0, 0)';
        }
        if (swiper.allowTouchMove !== undefined) swiper.allowTouchMove = false;
      } else {
        swiperEl.classList.remove('is-sim-centered');
        swiper.wrapperEl.style.width = '';
        swiper.wrapperEl.style.marginLeft = '';
        swiper.wrapperEl.style.marginRight = '';
        if (swiper.allowTouchMove !== undefined) swiper.allowTouchMove = true;
      }
    }

    function clearActiveClasses() {
      swiperEl.querySelectorAll('[data-see-it-in-motion-slide]').forEach(function (slide) {
        slide.classList.remove('is-sim-active');
      });
    }

    /** Visual active card (height/width/overlay/view-all). Video only if in viewport. */
    function setDesktopActive(index, options) {
      let slides = getSlides();
      if (!slides.length) return;

      let nextIndex = ((index % slides.length) + slides.length) % slides.length;
      activeHoverIndex = nextIndex;
      options = options || {};

      clearActiveClasses();
      slides[nextIndex].classList.add('is-sim-active');
      syncViewAllA11y(slides, nextIndex);

      pauseAllSlides(swiperEl);

      if (inViewport) {
        playSlideVideo(slides[nextIndex]);
      }

      // Active card grows (242→272); keep Swiper slide sizes in sync
      if (swiper && typeof swiper.update === 'function') {
        swiper.update();
      }

      syncDesktopCentering();

      if (options.slideTo === true && swiper && !swiperEl.classList.contains('is-sim-centered')) {
        try {
          if (swiper.params.loop) {
            swiper.slideToLoop(nextIndex, options.speed != null ? options.speed : 450);
          } else {
            swiper.slideTo(nextIndex, options.speed != null ? options.speed : 450);
          }
        } catch (e) {
          swiper.slideTo(nextIndex, options.speed != null ? options.speed : 450);
        }
      }
    }

    function stopAutoHover() {
      if (autoHoverTimer) {
        window.clearInterval(autoHoverTimer);
        autoHoverTimer = null;
      }
    }

    function startAutoHover() {
      stopAutoHover();
      if (isMobile() || isUserHovering || !inViewport || slideCount < 2) return;

      autoHoverTimer = window.setInterval(function () {
        setDesktopActive(activeHoverIndex + 1, { slideTo: false, speed: 450 });
      }, AUTO_HOVER_MS);
    }

    function syncPlayback() {
      if (isMobile()) {
        stopAutoHover();
        clearActiveClasses();
        if (!inViewport) {
          pauseAllSlides(swiperEl);
          return;
        }
        pauseAllSlides(swiperEl);
        let activeSlide = getActiveSlide(swiper, swiperEl);
        playSlideVideo(activeSlide);
        syncMobileViewAll(sectionEl, activeSlide);
        return;
      }

      // Desktop: always keep one card visually active
      setDesktopActive(activeHoverIndex, { slideTo: false });

      if (!inViewport) {
        stopAutoHover();
        pauseAllSlides(swiperEl);
        return;
      }

      startAutoHover();
    }

    function onSlideEnter(event) {
      if (isMobile()) return;
      let slide = event.currentTarget;
      let slides = getSlides();
      let index = slides.indexOf(slide);
      if (index < 0) return;

      isUserHovering = true;
      stopAutoHover();
      setDesktopActive(index, { slideTo: false, speed: 0 });
    }

    function onSlideLeave() {
      if (isMobile()) return;
      isUserHovering = false;
      if (inViewport) {
        startAutoHover();
      }
    }

    function bindHoverHandlers() {
      if (hoverBound) return;
      getSlides().forEach(function (slide) {
        slide.addEventListener('mouseenter', onSlideEnter);
        slide.addEventListener('mouseleave', onSlideLeave);
      });
      hoverBound = true;
    }

    function unbindHoverHandlers() {
      if (!hoverBound) return;
      getSlides().forEach(function (slide) {
        slide.removeEventListener('mouseenter', onSlideEnter);
        slide.removeEventListener('mouseleave', onSlideLeave);
      });
      hoverBound = false;
    }

    function createSwiper() {
      let desktop = !isMobile();

      return new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 32,
        centeredSlides: !desktop,
        autoHeight: false,
        loop: !desktop && slideCount > 1,
        loopAdditionalSlides: desktop ? 0 : 2,
        watchSlidesProgress: true,
        watchOverflow: true,
        speed: 500,
        grabCursor: true,
        breakpoints: {
          750: {
            slidesPerView: 'auto',
            spaceBetween: 32,
            centeredSlides: false,
            loop: false,
            watchOverflow: true,
          },
        },
        on: {
          init: function () {
            bindHoverHandlers();
            if (!isMobile()) {
              setDesktopActive(activeHoverIndex, { slideTo: false, speed: 0 });
            }
            requestAnimationFrame(syncDesktopCentering);
          },
          resize: function () {
            syncDesktopCentering();
          },
          update: function () {
            syncDesktopCentering();
          },
          slideChangeTransitionEnd: function () {
            if (isMobile()) {
              syncPlayback();
            } else {
              syncDesktopCentering();
            }
          },
          slideChange: function () {
            if (isMobile()) {
              pauseAllSlides(swiperEl);
            }
          },
        },
      });
    }

    swiper = createSwiper();

    let resizeTimer = null;
    function onWindowResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        syncDesktopCentering();
      }, 50);
    }
    window.addEventListener('resize', onWindowResize);

    function checkViewport() {
      let rect = sectionEl.getBoundingClientRect();
      let viewH = window.innerHeight || document.documentElement.clientHeight;
      let visible = Math.min(rect.bottom, viewH) - Math.max(rect.top, 0);
      let ratio = rect.height > 0 ? visible / rect.height : 0;
      return ratio > 0.2 || (rect.top < viewH && rect.bottom > 0 && visible > 120);
    }

    // Seed viewport immediately so first paint can activate + play
    inViewport = checkViewport();
    syncPlayback();

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            let nextInViewport =
              entry.isIntersecting && (entry.intersectionRatio > 0.15 || entry.intersectionRect.height > 120);
            if (nextInViewport === inViewport) return;
            inViewport = nextInViewport;
            syncPlayback();
          });
        },
        {
          root: null,
          threshold: [0, 0.15, 0.25, 0.5, 0.75, 1],
          rootMargin: '0px',
        }
      );
      observer.observe(sectionEl);
    }

    function onMediaChange() {
      isUserHovering = false;
      stopAutoHover();
      unbindHoverHandlers();

      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }

      swiper = createSwiper();
      inViewport = checkViewport();
      syncPlayback();
    }

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', onMediaChange);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(onMediaChange);
    }

    sectionEl.seeItInMotionDestroy = function () {
      stopAutoHover();
      unbindHoverHandlers();
      pauseAllSlides(swiperEl);
      window.removeEventListener('resize', onWindowResize);
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', onMediaChange);
      } else if (typeof mediaQuery.removeListener === 'function') {
        mediaQuery.removeListener(onMediaChange);
      }
      if (swiper && typeof swiper.destroy === 'function') {
        swiper.destroy(true, true);
      }
      delete sectionEl.dataset.seeItInMotionInit;
      delete sectionEl.seeItInMotionDestroy;
    };
  }

  function bootstrap(root) {
    let scope = root || document;
    if (scope.hasAttribute && scope.hasAttribute('data-see-it-in-motion-section')) {
      initSeeItInMotionSection(scope);
    }
    scope.querySelectorAll('[data-see-it-in-motion-section]').forEach(initSeeItInMotionSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootstrap();
    });
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    let sectionEl = event.target;
    if (!sectionEl) return;

    let target = sectionEl.hasAttribute('data-see-it-in-motion-section')
      ? sectionEl
      : sectionEl.querySelector('[data-see-it-in-motion-section]');

    if (!target) return;

    if (typeof target.seeItInMotionDestroy === 'function') {
      target.seeItInMotionDestroy();
    }

    bootstrap(target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    let sectionEl = event.target;
    if (!sectionEl) return;
    let target = sectionEl.hasAttribute('data-see-it-in-motion-section')
      ? sectionEl
      : sectionEl.querySelector('[data-see-it-in-motion-section]');
    if (target && typeof target.seeItInMotionDestroy === 'function') {
      target.seeItInMotionDestroy();
    }
  });
})();
